import React, { useEffect, useState } from "react";
import { useSpinnerContext, useSessionContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import { Bill, NoBill } from "@components";
import { Constants, Enums } from "@shared";

const Payor = () => {

    const { setSpinnerShow } = useSpinnerContext();
    const [tasks, setTasks] = useState(null);
    const { session, setSession, setShowAccountSelector } = useSessionContext();

    const { currentBill = null } = tasks || {};
    const { idAccount, idPayor, creditChecked } = session;

    useEffect(() => {
        (async () => {

            setSpinnerShow(true);
            try {
                const response = await sunboundPayProxy.refreshSession();
                setSession(response);
                setShowAccountSelector(true);
            } catch (error) {
                console.error(error);
            }
            setSpinnerShow(false);
        })();
    }, []);


    useEffect(() => {
        (async () => {
            setSpinnerShow(true);
            try {
                const responseTasks = await sunboundPayProxy.getPayorTasks(idAccount);
                setTasks(responseTasks);
            } catch (error) {
                console.error(error);
            }
            setSpinnerShow(false);
        })();

    }, [idAccount]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const alerts = [];

    if (currentBill) {
        const { idProductType, invitations } = currentBill;
        const invitation = invitations.find(i => i.idPayor === idPayor);
        const failedTransaction = invitation.payments.find(p => p.idTransactionStatus === Enums.TransactionStatus.declined);

        if(failedTransaction) {
            const transactionAction = Constants.FailedTransactionsActions.find((action) => action.statusCodes.includes(failedTransaction.transactionStatusCode));
            alerts.push({
                title: `Failed Transaction: ${failedTransaction.transactionStatusReason}`,
                content: transactionAction?.action || ``
            });
        }

        if (!creditChecked && idProductType === Enums.ProductType.SunboundPay)
            alerts.push({
                title: `Credit Check Pending`,
                content: `We are still confirming your eligibility for Pay Over Time. We'll be in touch within 24 hours with approval`
            });
    }

    if (session.paymentPreferences.hasDefaultPaymentMethodDisabled) {
        alerts.push({
            title: `Payment Method Disabled`,
            content: <>Please <a className="underline" href="/payment-method-settings">Go to Payment Settings</a> and update your payment method in order to continue making payments.</>
        });
    }

    return (
        <>
            {
                currentBill != null && <Bill currentBill={currentBill} alerts={alerts} />
            }
            {
                currentBill === null && <NoBill alerts={alerts} />
            }
        </>
    );
};

export default Payor;